import { useMemo } from 'react';
import type { QuoteFieldValue } from '../api/quotes.api.types';
import { getDeepNestedValueByKey } from '../utils/data.utils';

export const useGetClassDescription = (
  dynamicFields: QuoteFieldValue[]
): unknown => {
  const classDescriptionObject = useMemo(
    () => getDeepNestedValueByKey(dynamicFields, 'description'),
    [dynamicFields]
  );

  return classDescriptionObject?.value;
};
